import * as counter from './counter-service';
import * as user from './user-service';

const services = {
  counter,
  user,
};

export default services;
